export default "__VITE_ASSET__Dp2Q71Ba__"